module.exports = __webpack_public_path__ + "media/images/arrows-7130b96dd305af97d0da44b246255a08.svg";